import React, { useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

import localData from 'utils/localData';
import useApi from 'shared/hooks/api';
import { PageError, PageLoader } from 'components';
import { DOLPHIN_API, KENSHIN_API } from 'shared/constants/apis';
import { ServiceType } from 'shared/constants/service';
import { USER_DATA } from 'shared/constants/users';

import logger from 'utils/logger';

// DO NOT Remove the log and use for logging
const log = logger.createLogger('BrowseIssue');

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

// Handles redirect to the correct issue page
const BrowseIssue = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { issueId } = useParams();
  const currentOrganizationId = localData.get(
    USER_DATA.CURRENT_ORGANIZATION_ID
  );
  const currentUsername = localData.get(USER_DATA.USERNAME);
  const userId = localData.get(USER_DATA.USER_ID);
  const serviceType = query.get('serviceType');

  let apiUrl = '';
  let apiVariables;

  if (serviceType === ServiceType.SEIMITSU) {
    apiUrl = `${DOLPHIN_API.ISSUES}/${issueId}`;
    apiVariables = {
      params: {
        organizationId: currentOrganizationId,
      },
    };
  } else if (serviceType === ServiceType.KENSHIN) {
    apiUrl = `${KENSHIN_API.ISSUES}/${issueId}`;
    apiVariables = {
      params: {
        organizationId: currentOrganizationId,
        username: currentUsername,
        userId: userId,
      },
      baseURL: import.meta.env.VITE_KENSHIN_API_URL,
    };
  }

  const [{ data, error }] = useApi.useGet(apiUrl, apiVariables);

  // Move navigation logic to useEffect
  useEffect(() => {
    if (data) {
      const { issue } = data;
      const srcOrgId = issue.srcOrgId.toString();
      const dstOrgId = issue.dstOrgId.toString();
      const isSender = srcOrgId === currentOrganizationId;
      const isReceiver = dstOrgId === currentOrganizationId;

      if (serviceType === ServiceType.SEIMITSU) {
        if (isSender) {
          navigate(`/dashboard/history/sent/issues/${issueId}?from=Browse`);
        } else if (isReceiver) {
          navigate(`/dashboard/history/received/issues/${issueId}?from=Browse`);
        }
      } else if (serviceType === ServiceType.KENSHIN) {
        if (isSender) {
          navigate(
            `/dashboard/history/sent-kenshin/issues/${issueId}?from=Browse`
          );
        } else if (isReceiver) {
          navigate(
            `/dashboard/history/received-kenshin/issues/${issueId}?from=Browse`
          );
        }
      }
    }
  }, [data, serviceType, currentOrganizationId, issueId, navigate]);

  if (!data && !error) return <PageLoader />;

  if (data) {
    return <PageLoader />;
  }

  return (
    <PageError
      errorCode={error.response.status}
      customErrorMessage={error.response.data.message}
      customErrorDescription={error.response.data.description}
    />
  );
};

export default BrowseIssue;
